const services = [
  {
    icon: 'ri-building-2-line',
    title: 'Acompanhamento de Obras',
    description:
      'Monitoramento aéreo periódico de canteiros de obras com relatórios fotográficos e videográficos detalhados. Ideal para construtoras, engenheiros e gestores de projetos.',
    features: ['Relatórios mensais', 'Comparativo de progresso', 'Alta resolução 4K'],
    image: 'https://storage.readdy-site.link/project_files/d1351590-8cd2-45d9-bbe4-eacb238e475e/ab7eddc8-e0bf-4f53-9048-2973db7f333e_DJI_20260317181218_0078_D.jpg?v=98333c3cb2883d10ae0531a8c4c23d5c',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Fotos para Imobiliárias',
    description:
      'Imagens aéreas profissionais que valorizam imóveis residenciais e comerciais. Destaque seu portfólio com perspectivas únicas que encantam compradores.',
    features: ['Fotos e vídeos HD', 'Tour virtual 360°', 'Entrega em 48h'],
    image:
      'https://public.readdy.ai/ai/img_res/cb6fa9c4330f8e2f0636e93d45745848.jpg',
  },
  {
    icon: 'ri-camera-line',
    title: 'Cobertura de Eventos',
    description:
      'Registros aéreos únicos de eventos corporativos, shows, festivais e cerimônias. Imagens que capturam a grandiosidade do seu evento de forma inesquecível.',
    features: ['Transmissão ao vivo', 'Edição profissional', 'Múltiplos ângulos'],
    image:
      'https://readdy.ai/api/search-image?query=aerial%20drone%20view%20of%20large%20outdoor%20corporate%20event%20in%20Brazil%2C%20crowd%20of%20people%20at%20night%20with%20colorful%20lights%20and%20stage%2C%20concert%20photography%20from%20above%2C%20dramatic%20lighting%2C%20cinematic%20quality&width=600&height=400&seq=serv003&orientation=landscape',
  },
  {
    icon: 'ri-map-2-line',
    title: 'Mapeamento Aéreo',
    description:
      'Levantamentos topográficos e mapeamento de precisão com tecnologia LiDAR e fotogrametria. Dados geoespaciais confiáveis para projetos de engenharia e planejamento urbano.',
    features: ['Ortomosaicos', 'Modelos 3D', 'Precisão centimétrica'],
    image:
      'https://readdy.ai/api/search-image?query=aerial%20drone%20mapping%20survey%20of%20urban%20area%20in%20Sao%20Paulo%20Brazil%2C%20top%20down%20orthographic%20view%20of%20city%20blocks%20and%20streets%2C%20technical%20mapping%20photography%2C%20high%20altitude%20wide%20shot%2C%20professional%20geospatial%20imagery&width=600&height=400&seq=serv004&orientation=landscape',
  },
];

const Servicos = () => (
  <section id="servicos" className="bg-[#0d0d0d] py-24 px-6 md:px-10">
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <span className="inline-flex items-center gap-2 text-[#f5a623] text-xs font-bold tracking-widest uppercase mb-4">
            <span className="w-8 h-px bg-[#f5a623]"></span>
            O que fazemos
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
            Serviços Especializados<br />
            <span className="text-white/40">com Drone</span>
          </h2>
        </div>
        <p className="text-white/50 text-base max-w-sm leading-relaxed">
          Soluções aéreas completas para diferentes segmentos, com equipamentos de última geração e pilotos certificados pela ANAC.
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {services.map((service, idx) => (
          <div
            key={idx}
            className="group relative bg-[#141414] border border-white/8 rounded-2xl overflow-hidden hover:border-[#f5a623]/40 transition-all duration-300 cursor-pointer"
          >
            {/* Image */}
            <div className="relative h-52 overflow-hidden">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-transparent to-transparent"></div>
              <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center bg-[#f5a623] rounded-xl">
                <i className={`${service.icon} text-black text-lg`}></i>
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <h3 className="text-white text-xl font-bold mb-3">{service.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed mb-5">{service.description}</p>

              {/* Features */}
              <div className="flex flex-wrap gap-2 mb-5">
                {service.features.map((feat) => (
                  <span
                    key={feat}
                    className="text-[#f5a623] text-xs font-medium bg-[#f5a623]/10 border border-[#f5a623]/20 px-3 py-1 rounded-full whitespace-nowrap"
                  >
                    {feat}
                  </span>
                ))}
              </div>

              <a
                href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-white/70 hover:text-[#f5a623] text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Solicitar orçamento
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Servicos;
